import {Component, ElementRef, HostListener, OnInit, Renderer2, ViewChild} from '@angular/core';
import {BreakpointObserver} from '@angular/cdk/layout';
import {TrsService} from '@core-app/services/trs.service';

@Component({
    selector: 'core-floating-footer',
    templateUrl: './floating-footer.component.html',
    standalone: false
})
export class FloatingFooterComponent implements OnInit {
    isFloatingToggle!: boolean;
    isPrintPDFRoute!: boolean;
    isMobile!: boolean;
    @ViewChild('stickyFooter') stickyFooter?: ElementRef;

    constructor(
        protected trsService: TrsService,
        private renderer: Renderer2,
        protected breakpoint: BreakpointObserver,
    ) {
    }

    ngOnInit(): void {
        this.isPrintPDFRoute = this.trsService.isPrintRoute();

        this.breakpoint.observe([
            '(max-width: 450px)'
        ]).subscribe(result => {
            this.isMobile = result.matches;
        });
    }

    @HostListener('window:scroll') onScroll() {
        // Use different offset for mobile/desktop
        const offset = this.isMobile ? 350 : 550;
        const currentPosition = window.pageYOffset;
        if (this.stickyFooter) {
            if (currentPosition > offset) {
                if (!this.stickyFooter.nativeElement.classList.contains('is-active')) {
                    this.renderer.addClass(this.stickyFooter.nativeElement, 'is-active');
                }
            } else {
                this.renderer.removeClass(this.stickyFooter.nativeElement, 'is-active');
            }
        }
    }

}
